import dayjs, { Dayjs } from "utils/dayjs";
import { Guid } from "@/types";
import { toDateWithoutTimezone } from "utils/utils";
import { OverheadFactorsPhase } from "./OverheadFactors";

export enum OverheadFactorsKind {
    general = "general",
    individual = "individual",
}

export interface IOverheadFactorsPeriodDto {
    id: Guid
    kind?: OverheadFactorsKind | null
    phase?: OverheadFactorsPhase | null
    validFrom?: string | null
    validTo?: string | null
}

export interface ICreateOverheadFactorsPeriodDto {
    phase?: OverheadFactorsPhase
    kind?: OverheadFactorsKind
    validFrom?: string
}

export default class OverheadFactorsPeriod {
    id: Guid
    kind?: OverheadFactorsKind
    phase?: OverheadFactorsPhase
    validFrom?: Dayjs
    validTo?: Dayjs

    constructor(dto: IOverheadFactorsPeriodDto) {
        this.id = dto.id
        this.kind = dto.kind ?? undefined
        this.phase = dto.phase ?? undefined
        this.validFrom = dto.validFrom ? dayjs(dto.validFrom, "YYYY-MM-DD") : undefined
        this.validTo = dto.validTo ? dayjs(dto.validTo, "YYYY-MM-DD") : undefined
    }

    toDto(): IOverheadFactorsPeriodDto {
        return {
            id: this.id,
            kind: this.kind ?? null,
            validFrom: this.validFrom ? toDateWithoutTimezone(this.validFrom) : null,
            validTo: this.validTo ? toDateWithoutTimezone(this.validTo) : null,
        }
    }
}
